import { Typography, Button } from "../../components"
import "./styles.css";

import routekaartverloskundigenjgzkraamzorg from '../../assets/documents/library/routekaartverloskundigenjgzkraamzorg2026.pdf';

export default function RoutekaartVerloskundigenJgzKraamzorg(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Routekaart voor Verloskundigen, JGZ en Kraamzorg</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={routekaartverloskundigenjgzkraamzorg} 
                    text={`Klik hier voor onze Routekaart voor verloskundigen, JGZ en kraamzorg`}
                /> 
            </div>
        </div>
    )
}